import { CustomEdge } from './CustomEdge'

const edgeTypes = {
    customedge: CustomEdge
}

export {
    CustomEdge,
    edgeTypes
}